import React from 'react';

interface LanguageSelectorProps {
  availableLanguages: string[];
  selectedLanguage: string;
  onLanguageChange: (language: string) => void;
  className?: string;
}

export const LanguageSelector: React.FC<LanguageSelectorProps> = ({
  availableLanguages,
  selectedLanguage,
  onLanguageChange,
  className = ''
}) => {
  if (availableLanguages.length <= 1) {
    return null; // Don't show selector if only one language
  }

  return (
    <div className={`flex items-center gap-1 ${className}`}>
      {availableLanguages.map((lang) => (
        <button
          key={lang}
          onClick={() => onLanguageChange(lang)}
          className={`px-2 py-1 text-xs rounded transition-colors ${
            selectedLanguage === lang
              ? 'bg-blue-600 text-white'
              : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
          }`}
        >
          {lang.toUpperCase()}
        </button>
      ))}
    </div>
  );
};